import { render } from "./Footer.vue?vue&type=template&id=32b0f50f&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=32b0f50f&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b0f50f"]])